import React from 'react';
import PropTypes from 'prop-types';
import ProjectStatusLabel from '../ProjectStatusLabel';
var renderAction = function renderAction(proposal, status, acceptingProposals, projectLink) {
  if (proposal) {
    if (status === 'edits_requested') {
      return /*#__PURE__*/React.createElement("a", {
        href: "/proposals/".concat(proposal.resource_id),
        className: "btn btn-sm btn-primary me-3"
      }, "Review Feedback");
    }
    if (status === 'drafting') {
      return /*#__PURE__*/React.createElement("a", {
        href: "/proposals/".concat(proposal.resource_id),
        className: "btn btn-sm btn-primary me-3"
      }, "Review & Submit Proposal");
    }
    if (status === 'submitted' || status === 'awarded' || status === 'rejected') {
      return /*#__PURE__*/React.createElement("a", {
        href: "/proposals/".concat(proposal.resource_id),
        className: "btn btn-sm btn-default me-3"
      }, "View Proposal");
    }
  } else {
    if (acceptingProposals) {
      if (status === 'rejected') {
        return /*#__PURE__*/React.createElement("a", {
          href: projectLink,
          className: "btn btn-sm btn-default me-3"
        }, "View Opportunity");
      }
      return /*#__PURE__*/React.createElement("a", {
        href: projectLink,
        className: "btn btn-sm btn-primary me-3"
      }, "View Opportunity");
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "text-danger mb-0"
    }, "This project is no longer available");
  }
  return null;
};
function ConsultantProjectIndexRow(_ref) {
  var name = _ref.name,
    projectLink = _ref.projectLink,
    proposal = _ref.proposal,
    status = _ref.status,
    aoe = _ref.aoe,
    acceptingProposals = _ref.acceptingProposals,
    hours = _ref.hours,
    location = _ref.location;
  return /*#__PURE__*/React.createElement("div", {
    className: "row vertical-align"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12 col-sm-6 col-md-4"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "mt-0 mb-0"
  }, /*#__PURE__*/React.createElement("a", {
    href: projectLink,
    className: "project-show"
  }, name)), /*#__PURE__*/React.createElement("h4", {
    className: "mt-0 mb-0"
  }, /*#__PURE__*/React.createElement("small", null, aoe))), /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12 col-sm-6 col-md-3"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "mt-0 mb-0"
  }, /*#__PURE__*/React.createElement("small", {
    className: "label-text"
  }, "Weekly Committment: "), /*#__PURE__*/React.createElement("small", null, ' ', hours)), /*#__PURE__*/React.createElement("h4", {
    className: "mt-0 mb-0"
  }, /*#__PURE__*/React.createElement("small", {
    className: "label-text"
  }, "Position Type: "), /*#__PURE__*/React.createElement("small", null, ' ', location))), /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12 col-sm-6 col-md-2 text-center"
  }, /*#__PURE__*/React.createElement(ProjectStatusLabel, {
    status: status
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12 col-sm-6 col-md-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "btn-group pull-right"
  }, renderAction(proposal, status, acceptingProposals, projectLink))));
}
ConsultantProjectIndexRow.propTypes = {
  name: PropTypes.string.isRequired,
  proposal: PropTypes.shape({}),
  status: PropTypes.string.isRequired,
  projectLink: PropTypes.string.isRequired,
  acceptingProposals: PropTypes.bool,
  aoe: PropTypes.string,
  hours: PropTypes.string,
  location: PropTypes.string
};
ConsultantProjectIndexRow.defaultProps = {
  acceptingProposals: true,
  aoe: null,
  hours: null,
  location: null,
  proposal: null
};
export default ConsultantProjectIndexRow;